module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', {
    directives: [{
      name: "lang",
      rawName: "v-lang.useful_links",
      modifiers: {
        "useful_links": true
      }
    }]
  }), _vm._v(" "), _c('ul', {
    staticClass: "useful_links"
  }, [_c('li', [_c('router-link', {
    directives: [{
      name: "lang",
      rawName: "v-lang.habitaciones",
      modifiers: {
        "habitaciones": true
      }
    }],
    attrs: {
      "to": "/site/rooms"
    }
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    directives: [{
      name: "lang",
      rawName: "v-lang.contacto",
      modifiers: {
        "contacto": true
      }
    }],
    attrs: {
      "to": "/site/contact"
    }
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    directives: [{
      name: "lang",
      rawName: "v-lang.blog",
      modifiers: {
        "blog": true
      }
    }],
    attrs: {
      "to": "/site/blog"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-babf5d1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/Links.vue
// module id = 390
// module chunks = 0